import { render, staticRenderFns } from "./ProductSell.vue?vue&type=template&id=b3ce0822&scoped=true"
import script from "./ProductSell.vue?vue&type=script&lang=js"
export * from "./ProductSell.vue?vue&type=script&lang=js"
import style0 from "./ProductSell.vue?vue&type=style&index=0&id=b3ce0822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce0822",
  null
  
)

export default component.exports